var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#D50525",
  clipPath: "url(#alertCircle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 14.781A6.782 6.782 0 1 1 14.781 8 6.79 6.79 0 0 1 8 14.781m0-12.25A5.469 5.469 0 1 0 8 13.47 5.469 5.469 0 0 0 8 2.53"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.055 4.631a3.5 3.5 0 0 1 1.89 0l-.481 4.244h-.928zm1.82 5.994a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "alertCircle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1 1h14v14H1z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertCircle);
export default ForwardRef;